import React, { useState } from 'react';
import classnames from 'classnames';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const AbbreviationAnnotation = ({ title, children, ...props }) => {
  const [visible, setVisible] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    setVisible(!visible);
  };

  const className = classnames('AbbreviationAnnotationLink', {
    'AbbreviationAnnotationLink--uncollapsed': visible,
  });

  const classNameInfo = classnames('AbbreviationAnnotation', {
    'AbbreviationAnnotation--visible': visible,
  });

  return (
    <>
      <a id={children} className={className} onClick={handleClick} {...props}>
        <span className="AbbreviationAnnotationLink__content">
          <i className="icon icon-info icon-variant-2" />
          { children }
          <i className="icon icon-chevron-down icon-variant-2" />
        </span>
      </a>
      <div className={classNameInfo}>
        <i className="icon icon-info icon-variant-2" />
        <div>
          <WysiwygField
            property="schema:text"
            html={title}
          />
        </div>
      </div>
    </>
  );
};

export default AbbreviationAnnotation;
